import {
  __ONLY_WRITE_STATE_FROM_ACTIONS as writeState,
  readState,
} from "@/__main__/app-state.mjs";
import { IS_APP, IS_NODE, isPersistent } from "@/__main__/constants.mjs";
import { readData } from "@/__main__/get-data.mjs";
import initialState from "@/__main__/initial-state.mjs";
import router from "@/__main__/router.mjs";
import eventBus from "@/app/app-event-bus.mjs";
import { appURLs, EVENT_APP_DOWNLOAD } from "@/app/constants.mjs";
import { useClientOnly } from "@/util/ClientOnly.jsx";
import clone from "@/util/clone.mjs";
import getOSType from "@/util/get-os-type.mjs";
import globals from "@/util/global-whitelist.mjs";
import optionalMerge from "@/util/optional-merge.mjs";
import { stringifyPath } from "@/util/path-regexp.mjs";

const OS_TYPE = (() => {
  const value = getOSType();
  // Default to windows...
  return value === "darwin" ? "darwin" : "win32";
})();

const DOWNLOAD_URLS = {
  [null]: `${IS_APP ? appURLs.BLITZ : ""}/download`,
  win32: `${IS_APP ? appURLs.BLITZ : ""}/download/win`,
  darwin: `${IS_APP ? appURLs.BLITZ : ""}/download/mac`,
};

let initReferrerInfoPromise = null;
export function initReferrerInfo() {
  if (IS_APP) return null;
  if (!initReferrerInfoPromise) {
    initReferrerInfoPromise = (async () => {
      const referrerInfo = clone(
        (await readData(["marketing", "referrerInfo"])) ||
          initialState.marketing.referrerInfo,
      );

      const { document: { referrer } = {} } = globals;
      const isExternal =
        referrer && !/^https?:\/\/localhost|blitz\.gg/i.test(referrer);
      if (isExternal) {
        optionalMerge(referrerInfo, {
          referrer,
        });
      }

      // Expected behavior: persist the current referrer for the next 30 days.
      referrerInfo[isPersistent] = Date.now() + 30 * 24 * 60 * 60 * 1000;
      writeState.marketing.referrerInfo = referrerInfo;
    })();
  }
  return initReferrerInfo;
}

export default function downloadApp(event, uiLocation) {
  const canDownload = !IS_APP && !IS_NODE;
  if (!canDownload) {
    throw new Error("Failed sanity check to download app!");
  }

  if (typeof event?.preventDefault === "function") {
    event.preventDefault();
  }

  emitDownload(uiLocation);

  // Hacky way of initiating download.
  const element = globals.document.createElement("a");
  element.setAttribute("href", DOWNLOAD_URLS[OS_TYPE]);
  element.setAttribute("download", "");
  element.click();
}

export async function emitDownload(uiLocation) {
  await initReferrerInfo();
  const payload = {
    origin: readState.marketing.referrerInfo.referrer,
    url: globals.location.href,
    route: stringifyPath(router.route.path),
  };
  if (uiLocation) payload.uiLocation = uiLocation;
  eventBus.emit(EVENT_APP_DOWNLOAD, payload);
}

export function useDownloadLink() {
  const isHydrated = useClientOnly();

  return DOWNLOAD_URLS[!isHydrated ? null : OS_TYPE];
}
